import { hasMeaningfulValue } from '../../../utils';

/** 网络带宽是否已配置（只读展示时无值则隐藏） */
export function hasBandwidthValue(value: unknown): boolean {
  if (!hasMeaningfulValue(value)) return false;
  const num = Number(value);
  return Number.isFinite(num) && num > 0;
}
